module.exports = __webpack_public_path__ + "static/img/sec5-slide03.6cef332.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/design-samsung/sec5-slide03.png
// module id = /tRd
// module chunks = 0